// extracted by mini-css-extract-plugin
export default {"root":"ERP_root__eiCGC"};